import { appConfig } from "../aLwAJXh7rUuwykLl";
const getBrandFromLocation = () => {
  const location = window.location.hostname;
  return location.split("-")[0];
};

const getSubdomainFromLocation = () => {
  const location = window.location.hostname;
  return location.split(".").slice(1).join(".");
};

const getAccessBrand = () => {
  const brand = getBrandFromLocation();
  const subdomain = getSubdomainFromLocation();

  const brandUrls = {
    hourglass: "https://api-hourglass-mobile-prod.dosetech.co",
    linecrm: "https://api-crm-mobile-dev.dosetech.co",
    "crmmobile.dosetech.co": "https://api-dcrmmulti-mobile-prod.d-dots.com",
    d: "https://api-dcrmmulti-mobile-prod.d-dots.com",
    dcrm: "https://api-dcrm-demo-mobile.dosetech.co",
    clarins: "https://clubbeaute-mobile-api.dosetech.co",
    uat: "https://api-uat-bdmswellness-mobile-prod.d-crm.co",
    alo: "https://api-alo-pre-prod-mobile-prod.d-dots.com"
    // orlebarbrownthailand:
    //   "https://api-orlebarbrownthailand-pre-prod-mobile-prod.d-dots.com",
    // costhailand: "https://api-costhailand-pre-prod-mobile-prod.d-dots.com"
  };

  // match ด้วย hostname เต็ม สำหรับ environment ที่ไม่เข้า pattern ปกติ
  const hostUrls = {
    "visionventures-sandbox-crm.d-dots.com":
      "https://api-visionventures-sandbox-mobile-prod.d-dots.com"
  };

  if (hostUrls[window.location.hostname]) {
    return hostUrls[window.location.hostname];
  }

  if (brandUrls[brand]) {
    return brandUrls[brand];
  }

  if (appConfig.NODE_ENV === "development") {
    return "https://api-dcrmmulti-mobile-prod.d-dots.com";
  }

  return `${window.location.protocol}//api-${brand}-mobile-${appConfig.VUE_APP_MODE}.${subdomain}`;
};

export { getAccessBrand };
